import type { ZodError } from "zod";
import {
  BadRequestError,
  ConflictError,
  ForbiddenError,
  HttpError,
  InternalServerError,
  NotFoundError,
  UnauthorizedError,
} from "@/lib/errors";
import { createLogger } from "@/lib/logger";

const rawLogger = createLogger("");

export {
  BadRequestError,
  ConflictError,
  ForbiddenError,
  HttpError,
  InternalServerError,
  NotFoundError,
  UnauthorizedError,
};
export class DatabaseError extends Error {
  constructor(
    message: string,
    public originalError: any,
  ) {
    super(message);
    this.name = "DatabaseError";
  }
}

export class StripeError extends Error {
  constructor(
    message: string,
    public originalError: any,
  ) {
    super(message);
    this.name = "StripeError";
  }
}

export function formatZodError(error: ZodError) {
  return error.issues.map((err) => `${err.path.join(".")}: ${err.message}`);
}

export function prettyPrintError(error: Error) {
  const errorName = error.name || "Unknown Error";
  const message = error.message || "No error message provided";
  const stack =
    error.stack
      ?.split("\n")
      .slice(2)
      .map((line) => line.trim()) || [];

  const header = "//------------------------------------------------------------------------";
  const nameLength = errorName.length;
  const padding = Math.floor((70 - nameLength) / 2);
  const paddedName = " ".repeat(padding) + errorName;
  const redColor = "\x1b[31m";
  const purpleColor = "\x1b[35m";
  const resetColor = "\x1b[0m";

  const lines = [
    `${redColor}${header}${resetColor}`,
    `${redColor}// ${paddedName}${resetColor}`,
    `${redColor}${header}${resetColor}`,
    ...message.split("\n").map((line) => `${redColor}//  ${line}${resetColor}`),
    `${redColor}//`,
    `${redColor}//  ${purpleColor}Call Stack:${resetColor}`,
    ...stack
      .filter((line) => !line.includes("node_modules") && !line.includes("node:internal"))
      .map((line) => `${redColor}//    ${purpleColor}${line}${resetColor}`),
    `${redColor}//${resetColor}`,
  ];

  lines.forEach((line) => {
    rawLogger.error(line);
  });
}
